import React, { useContext } from 'react';
import { IconArrow, IconMap } from '@components/icons';
import { ImageDate } from '@components/image-date';
import { NavigationBackButton } from '@components/navigation-back-button';
import { StepperWrapper } from '@components/stepper-wrapper';
import { Tabs } from '@components/tabs';
import { ROUNDED_TAB_BLACK_VARIANT, TAB_TYPE_ROUNDED } from '@components/tabs/src/tabs.type';
import { EventContext } from '@contexts/event/event-context';

import { EventHeaderActions } from '../../event-header-actions';

import { EventHeaderProps } from './event-header.type';

export const EventHeader = ({
  isLessThanTablet,
  buttonPreviewText,
  buttonViewText,
  buttonReportText,
  tabs,
  steps,
  currentStep,
  publishedActions,
  unpublishedActions,
  reportPath,
  backRoute,
  openPreview,
  handleChangeTab,
}: EventHeaderProps) => {
  const { eventState } = useContext(EventContext);
  const { startingTime, name, coverUrl, venue, isPublished, duplicatePath, isLiveEvent } = eventState;
  return (
    <header className='w-full flex bg-surface-primary pt-10 pb-4 md:pb-6'>
      <div className='flex flex-col justify-between w-full max-w-7xl mx-auto'>
        <NavigationBackButton defaultRoute={backRoute} className='pl-3.5 mb-6' forceDefaultRoute={true}>
          <IconArrow className='w-5 h-5 text-primary rotate-180' />
        </NavigationBackButton>
        <div className='flex justify-between items-center mb-6 md:mb-10 gap-6 px-4 '>
          <div className='flex gap-3 md:gap-4 items-start'>
            <div className='w-16 h-16 relative shrink-0'>
              <ImageDate
                date={startingTime as number}
                name={name as string}
                timezone={eventState.timezone}
                width={isLessThanTablet ? 96 : 128}
                height={isLessThanTablet ? 112 : 128}
                round={'full'}
                image={coverUrl as string}
              />
            </div>
            <div className=''>
              <h1 className='text-primary text-headline-s md:text-headline-m lg:text-headline-l mb-1 sm:mb-1.5'>
                {name}
              </h1>
              <p className='text-primary inline-flex items-center gap-1'>
                <IconMap className='w-4 h-4 md:w-5 md:h-5' />
                <span className='text-subtitle-xs md:text-subtilte-s lg:text-subtitle-m'>{venue}</span>
              </p>
            </div>
          </div>
          <div className='flex gap-3 items-center'>
            <EventHeaderActions
              {...{
                isPublished,
                isLiveEvent,
                isLessThanTablet,
                reportPath,
                duplicatePath,
                publishedActions,
                unpublishedActions,
                openPreview,
                buttonPreviewText,
                buttonViewText,
                buttonReportText,
              }}
            />
          </div>
        </div>
        {isPublished ? (
          <Tabs
            tabs={tabs}
            activeTab={currentStep as string}
            onChange={handleChangeTab}
            type={TAB_TYPE_ROUNDED}
            roundedVariant={ROUNDED_TAB_BLACK_VARIANT}
            scrollable
            paddingClasses='pl-4 pb-0'
          />
        ) : (
          <div className='pl-4'>
            <StepperWrapper steps={steps} currentStep={currentStep as string} />
          </div>
        )}
      </div>
    </header>
  );
};
